module.exports = __webpack_public_path__ + "/login_ui/img/sb-9dfcf0dd67b43eea9dec7c11b271782d.svg";